/* global jQuery */
import { getCookie, setCookie } from '../../../js/helpers/cookies';

(function ($, A11yDialog) {
	$.body = $.body || $('body');
	const $html = $('html');
	// const $page = $('.site-wrapper');
	const $dialog = $.$body.find('.accessible-dialog');

	if (!$dialog.length || !A11yDialog) {
		return false;
	}

	const frequency = $dialog.data('frequency') || 'always';
	const cookieName = $dialog.data('cookie-name');
	const noCookie = !getCookie(cookieName) || frequency === 'always';

	console.log($dialog, { frequency, cookieName, noCookie });

	const initializeModal = () => {
		// lazy load all images or iframes
		$dialog.find('[data-src]').each((i, el) => {
			const $img = $(el);
			const { src, srcset, sizes } = $img.data();
			$img.attr('src', $img.data('src'));
			if (src) {
				el.src = src;
			}
			if (srcset) {
				el.srcset = srcset;
			}
			if (sizes) {
				el.sizes = sizes;
			}
		});

		const dialog = new A11yDialog($dialog.get(0));

		// console.log('d', dialog);
		dialog
			.on('show', (/* dialogEl, event */) => {
				$html.addClass('modal-active');
			})
			.on('hide', (/* dialogEl, event */) => {
				$html.removeClass('modal-active');
				setTimeout(() => dialog.destroy(), 400);
			})
			.on('destroy', () => $dialog.remove());

		dialog.show();
		$dialog.on('click', '.dialog-close', () => dialog.hide());

		const removeOnEscape = (e) => {
			if (e.keyCode === 27) {
				dialog.hide();
			}
			$(document).off('keyup', removeOnEscape);
		};

		$(document).on('keyup', removeOnEscape);
	};

	const cookieLengths = {
		week: 7,
		once: 999,
	};

	if (noCookie) {
		initializeModal();
		window.name = 'p';
		if (frequency !== 'always') {
			if (frequency === 'session') {
				setCookie(cookieName, 'shown');
			} else {
				setCookie(cookieName, 'shown', cookieLengths[frequency]);
			}
		}
	}

	return true;
})(jQuery, window.A11yDialog);
